import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import SvgIcon from "../SvgIcon/SvgIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationText',
  props: {
    errorMessage: {},
    noIndent: { type: Boolean },
    dataTestName: {}
  },
  setup(__props: any) {

const props = __props;



const dataTestErrorName = computed(() => (props.dataTestName ? `${props.dataTestName}-error` : ""));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _normalizeProps({
    class: ["flex pt-1 text-xs text-error", { 'pl-4': !_ctx.noIndent }],
    [dataTestErrorName.value || ""]: '',
    "aria-live": "polite"
  }), [
    (_ctx.errorMessage?.trim())
      ? (_openBlock(), _createBlock(SvgIcon, {
          key: 0,
          "icon-name": "error",
          class: "mr-1 h-3.5 w-3.5 shrink-0"
        }))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)
  ], 16))
}
}

})